import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    description: 'Settings Inventory Warehouses Title',
    defaultMessage: 'Warehouses',
    id: 'ADRmVJ',
  },
  pageHelperText: {
    description: 'Settings Inventory Warehouses Title',
    defaultMessage:
      'Add your warehouses to keep track of your inventory. You can organize your warehouses by creating inventory locations, and make your picking and packing operations run smoother by creating totes.',
    id: 'ZQ77Yv',
  },
  configureInventoryWarehouseModalTitle: {
    description: 'Settings Inventory Warehouses ConfigureInventoryWarehouseModal Title',
    defaultMessage: 'Inventory Warehouse',
    id: 'lvN6et',
  },
  configureInventoryWarehouseModalHelperText: {
    description: 'Settings Inventory Warehouses ConfigureInventoryWarehouseModal Helper Text',
    defaultMessage:
      'An Inventory Warehouse is a physical location that houses your inventory. You likely have the Warehouse Locations broken down into three dimensions (e.g. aisle, shelf, and bin), but you’re able to define between one and four dimensions, depending on the complexity of your Warehouse Location numbering system.',
    id: 'PuZotn',
  },
  configureInventoryWarehouseModalInputLabel: {
    description: 'Settings Inventory Warehouses ConfigureInventoryWarehouseModal Input Label',
    defaultMessage: 'Name',
    id: '5UqMVL',
  },
  configureInventoryWarehouseModalLinkedShipFromsLabel: {
    description: 'Settings Inventory Warehouses ConfigureInventoryWarehouseModal Input Label',
    defaultMessage: 'Linked "Ship From Locations"',
    id: 'ELIyrM',
  },
  configureInventoryWarehouseModalSaveButton: {
    description: 'Settings Inventory Warehouses ConfigureInventoryWarehouseModal Save Button',
    defaultMessage: 'Save',
    id: 'CTydoS',
  },
  deleteWarehouseModalTitle: {
    description: 'Settings Inventory Warehouses DeleteLocationModal Title',
    defaultMessage: 'Delete {inventoryWarehouseName}',
    id: '6keFB0',
  },
  deleteWarehouseModalPrompt: {
    description: 'Settings Inventory Warehouses DeleteLocationModal Prompt',
    defaultMessage:
      'Confirm that you wish to delete this inventory {locationType, select, warehouse {warehouse} location {location} other {warehouse}}. To undo this action, you will need to recreate the {locationType, select, warehouse {warehouse} location {location} other {warehouse}} and reapply it to all appropriate products.',
    id: 'LX477J',
  },
  deleteWarehouseModalDeleteButton: {
    description: 'Settings Inventory Warehouses DeleteLocationModal Delete Button',
    defaultMessage: 'Delete',
    id: 'wieG7+',
  },
  deleteWarehouseConfirmationModalTitle: {
    description: 'Settings Inventory Warehouses Confirmation Modal Title',
    defaultMessage: 'Confirm Warehouse Deletion',
    id: 'SxeZ27',
  },
  deleteLocationConfirmationModalTitle: {
    description: 'Settings Inventory Location Confirmation Modal Title',
    defaultMessage: 'Confirm Warehouse Location Deletion',
    id: '/l/0Dr',
  },
  deleteWarehouseConfirmationHeader: {
    description: 'Settings Inventory Warehouses Delete Confirmation Notification Header',
    defaultMessage: 'Deleting this warehouse will result in the following:',
    id: 'pcAK40',
  },
  deleteWarehouseConfirmationUnassignStock: {
    description: 'Settings Inventory Warehouses Delete Confirmation Unassign Stock',
    defaultMessage: 'All stock from {inventoryWarehouseName} assigned to orders will be unassigned.',
    id: 'wWd32X',
  },
  deleteWarehouseConfirmationRemoveInventory: {
    description: 'Settings Inventory Warehouses Delete Confirmation Remove Inventory',
    defaultMessage: 'All inventory stored in {inventoryWarehouseName} will be permanently removed.',
    id: 'ruTKCI',
  },
  deleteWarehouseConfirmationDeleteLocations: {
    description: 'Settings Inventory Warehouses Delete Confirmation Delete Locations',
    defaultMessage: 'All locations within {inventoryWarehouseName} will be permanently deleted.',
    id: 'wdeZxP',
  },
  deleteLocationConfirmationMessage: {
    description: 'Settings Inventory Warehouses Delete Location Confirmation Message',
    defaultMessage: 'Deleting this warehouse location will be permanent.',
    id: 'SHhZPK',
  },
  deleteWarehouseConfirmationFooter: {
    description: 'Settings Inventory Warehouse Delete Confirmation Prompt',
    defaultMessage: 'Are you sure you want to continue?',
    id: 'Zdn02H',
  },
  editLocationDisplayButtonLabel: {
    description: 'Settings Inventory Warehouses ManageLocationsModal EditLocationDisplayButton Label',
    defaultMessage: 'Warehouse Layout:',
    id: '/sf0Ag',
  },
  errorModalTitle: {
    description: 'Settings Inventory Warehouses ErrorModal Title',
    defaultMessage: 'Error',
    id: 'UuYRt1',
  },
  inventoryLocationArea: {
    description: 'Settings Inventory Warehouses Inventory Location Area',
    defaultMessage: 'Area',
    id: 'YpSN+c',
  },
  inventoryLocationUnit: {
    description: 'Settings Inventory Warehouses Inventory Location Unit',
    defaultMessage: 'Unit',
    id: 'QX1/Ls',
  },
  inventoryLocationShelf: {
    description: 'Settings Inventory Warehouses Inventory Location Shelf',
    defaultMessage: 'Shelf',
    id: 'xlEDN7',
  },
  inventoryLocationBin: {
    description: 'Settings Inventory Warehouses Inventory Location Bin',
    defaultMessage: 'Bin',
    id: 's9QHRd',
  },
  inventoryLocationBarcode: {
    description: 'Settings Inventory Warehouses Inventory Location Barcode',
    defaultMessage: 'Barcode',
    id: '/U1ab8',
  },
  warehousesGridEditButton: {
    description: 'Settings Inventory Warehouses Grid Edit Button',
    defaultMessage: 'Edit',
    id: 'P3xeQ9',
  },
  warehousesGridManageLocationsButton: {
    description: 'Settings Inventory Warehouses Grid Manage Locations Button',
    defaultMessage: 'Manage Locations',
    id: 'DNE8dK',
  },
  warehousesGridDeleteButton: {
    description: 'Settings Inventory Warehouses Grid Delete Button',
    defaultMessage: 'Delete...',
    id: 'uAns8u',
  },
  warehousesGridHeaderNameColumn: {
    description: 'Settings Inventory Warehouses Grid Header Name Column',
    defaultMessage: 'Name',
    id: 'qZ1glr',
  },
  warehousesGridHeaderLocationsColumn: {
    description: 'Settings Inventory Warehouses Grid Location Name Column',
    defaultMessage: 'Locations',
    id: 'kJubYo',
  },
  warehousesGridHeaderTotesColumn: {
    description: 'Settings Inventory Warehouses Grid Location Totes Column',
    defaultMessage: 'Totes',
    id: 'cm5ns8',
  },
  warehousesGridHeaderIsLinkedColumn: {
    description: 'Settings Inventory Warehouses Grid Header isLinked Column',
    defaultMessage: 'Linked Ship From Location',
    id: 'DERKZG',
  },
  warehousesGridHeaderActionsColumn: {
    description: 'Settings Inventory Warehouses Grid Header Actions Column',
    defaultMessage: 'Actions',
    id: 'pD6/by',
  },
  warehousesGridAddWarehouseButton: {
    description: 'Settings Inventory Warehouses Grid Add Warehouse Button',
    defaultMessage: 'Add Warehouse',
    id: 'EVUZgM',
  },
  manageLocationsDrawerCardTitle: {
    description: 'Settings Inventory Warehouses Manage Locations Drawer Card Title',
    defaultMessage: 'Configure Warehouse',
    id: 'Wtv4zF',
  },
  manageLocationsDrawerDescriptionLocations: {
    description: 'Settings Inventory Warehouses Manage Locations Drawer Description Locations',
    defaultMessage: 'Create, edit and delete your inventory locations.',
    id: 'MJKS57',
  },
  manageLocationsDrawerTabTitleLocations: {
    description: 'Settings Inventory Warehouses Manage Locations Drawer Tab Title Locations',
    defaultMessage: 'Locations',
    id: 'yX1PNH',
  },
  manageLocationsDrawerTabTitleTotes: {
    description: 'Settings Inventory Warehouses Manage Locations Drawer Tab Title Totes',
    defaultMessage: 'Totes',
    id: 'cWZ82F',
  },
  manageLocationsModalGridSaveButton: {
    description: 'Settings Inventory Warehouses ManageLocationsModal Grid Save Button',
    defaultMessage: 'Save',
    id: 'AKztfC',
  },
  manageLocationsModalGridCancelButton: {
    description: 'Settings Inventory Warehouses ManageLocationsModal Grid Cancel Button',
    defaultMessage: 'Cancel',
    id: 'bcwdaE',
  },
  manageLocationsModalGridDeleteButton: {
    description: 'Settings Inventory Warehouses ManageLocationsModal Grid Delete Button',
    defaultMessage: 'Delete...',
    id: 'G7zfpP',
  },
  manageLocationsModalGridEditButton: {
    description: 'Settings Inventory Warehouses ManageLocationsModal Grid Edit Button',
    defaultMessage: 'Edit',
    id: 'w0/VdB',
  },
  manageLocationsModalGridIsActiveColumnHeader: {
    description: 'Settings Inventory Warehouses ManageLocationsModal isActive Column Header',
    defaultMessage: 'Active',
    id: 'fPHMAK',
  },
  manageLocationsModalGridAddLocationButton: {
    description: 'Settings Inventory Warehouses ManageLocationsModal Add Location Button',
    defaultMessage: 'Add Location',
    id: 'j5Kopa',
  },
  manageLocationsModalGridPlaceholderText: {
    description: 'Settings Inventory Warehouses ManageLocationsModal Grid Placeholder Text',
    defaultMessage: 'There are currently no records',
    id: 'sLMqRI',
  },
  manageLocationsModalGridShowInactiveCheckbox: {
    description: 'Settings Inventory Warehouses ManageLocationsModal Show Inactive Locations Checkbox',
    defaultMessage: 'Show Inactive Locations',
    id: 'okZPgO',
  },
  inventoryWarehouseDeleteErrorLinkedToShipFroms: {
    description: 'Settings Inventory Warehouses Delete Error LinkedToShipFroms',
    defaultMessage: "It's linked to one or more Ship From Locations.",
    id: 'VPbRnY',
  },
  inventoryWarehouseDeleteErrorContainsLocations: {
    description: 'Settings Inventory Warehouses Delete Error ContainsLocations',
    defaultMessage: 'It has one or more specified Warehouse Locations.',
    id: 'RjJV5s',
  },
  inventoryWarehouseDeleteErrorContainsStock: {
    description: 'Settings Inventory Warehouses Delete Error ContainsLocations',
    defaultMessage: 'It contains stock.',
    id: '/dBgx4',
  },
  inventoryWarehouseDeleteErrorNotificationHeader: {
    description: 'Settings Inventory Warehouses Delete Error Notification Header',
    defaultMessage: '"{warehouseName}" can\'t be deleted because:',
    id: 'bKLeSj',
  },
  inventoryWarehouseDeleteErrorNotificationFooter: {
    description: 'Settings Inventory Warehouses Delete Error Notification Footer',
    defaultMessage: 'Try again after addressing the issues above.',
    id: 'SQNNBJ',
  },
  inventoryLocationDeleteErrorContainsStock: {
    description: 'Settings Inventory Location Delete Error ContainsLocations',
    defaultMessage: 'Unable to delete inventory locations with currently assigned inventory.',
    id: 'Br2dEP',
  },
  inventoryWarehouseGenericError: {
    description: 'Settings Inventory Warehouse Generic Error',
    defaultMessage: 'Your request could not be completed. Please try again later.',
    id: 'Y12Z9v',
  },
  inventoryWarehouseDuplicateLocationNotificationContent: {
    description: 'Settings Inventory Warehouse Duplicate Inventory Location Error',
    defaultMessage: 'A location with those values (Area x, Unit x, Shelf x, Bin x) already exists. Please try again with unique values.',
    id: 'kZ6Rtt',
  },
  inventoryWarehouseToteDuplicateError: {
    description: 'Settings Inventory Warehouse Duplicate Tote Error',
    defaultMessage: 'This barcode is already in use. Please enter a unique one.',
    id: '9OmEJf',
  },
  closeConfigureWarehouseButtonAriaLabel: {
    description: 'Aria label for the close button in the configure warehouse drawer',
    defaultMessage: 'Close',
    id: 'DtJ/Mk',
  },
  configureWarehouseDrawerHeaderText: {
    description: 'Text displayed in the header of the configure warehouse drawer',
    defaultMessage: 'Configure Warehouse',
    id: 'Q8WqHQ',
  },
  toteNameHeader: {
    description: 'Header for the tote name column in the warehouse drawer',
    defaultMessage: 'Tote Name',
    id: 'lXzWf1',
  },
  barcodeNameHeader: {
    description: 'Header for the barcode name column in the warehouse drawer',
    defaultMessage: 'Barcode',
    id: 'r6UXa/',
  },
  actionsHeader: {
    description: 'Header for the actions column in the warehouse drawer',
    defaultMessage: 'Actions',
    id: '+7YDVL',
  },
  tableDescription: {
    description: 'Description for the totes table in the warehouse drawer',
    defaultMessage: 'Create, edit, and print barcodes for your warehouse’s totes.',
    id: 'VcsAkj',
  },
  tableLearnMoreLink: {
    description: 'Link text for learning more about totes in the warehouse drawer',
    defaultMessage: 'Learn more about Pick-to-tote here. {icon}',
    id: 'Ap8/8N',
  },
  printTote: {
    description: 'Button text for printing tote barcodes in the warehouse drawer',
    defaultMessage: 'Print Barcode',
    id: 'ZhiGMA',
  },
  deleteTote: {
    description: 'Button text for deleting totes in the warehouse drawer',
    defaultMessage: 'Delete',
    id: '+kwVy+',
  },
  createTotes: {
    description: 'Button text for creating new totes in the warehouse drawer',
    defaultMessage: 'Create Totes',
    id: 'pdHVX+',
  },
  editTote: {
    description: 'Button text for editing a tote in the warehouse drawer',
    defaultMessage: 'Edit',
    id: 'ZGCBTO',
  },
  closeCreateTotesButtonAriaLabel: {
    description: 'Aria label for the close button in the create totes drawer',
    defaultMessage: 'Close',
    id: 'yjJe0M',
  },
  createTotesDrawerHeaderText: {
    description: 'Text displayed in the header of the create totes drawer',
    defaultMessage: 'Create Totes',
    id: 'mCeZM3',
  },
  cancelButton: {
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
    id: 'hHNj31',
  },
  createButton: {
    description: 'Create button text',
    defaultMessage: 'Create',
    id: 'zKU3d1',
  },
  createAndPrintBarcodeButton: {
    description: 'Create and print barcode button text',
    defaultMessage: 'Create + Print Barcode',
    id: 'ULAc8R',
  },
  createTotesContentTitle: {
    description: 'Title for the create totes content area',
    defaultMessage: 'Create New Totes',
    id: 'zMntLQ',
  },
  createTotesContentDescription: {
    description: 'Description for the create totes content area',
    defaultMessage: 'Create new totes for {warehouseName} warehouse to organize your inventory picking and packing operations.',
    id: 'Detv0x',
  },
  createTotesContentPlaceholder: {
    description: 'Placeholder text for the create totes content area',
    defaultMessage: 'Content will be added here later...',
    id: 'gLBuP4',
  },
  ariaPenIcon: {
    defaultMessage: 'Edit warehouse name',
    description: 'Label for a button that edits the warehouse name',
    id: 'ahKXZt',
  },
  manageShipFromLocationsMessage: {
    description: 'Tooltip footer message to manage shippings',
    defaultMessage: 'Manage your Ship From Locations in your {link}',
    id: 'qfGR98',
  },
  shippingSettingsLinkText: {
    description: 'Link text for shipping settings',
    defaultMessage: 'Shipping settings.',
    id: 's9CFa0',
  },
  linkedShipFromLocationsTitle: {
    description: 'Title for linked ship locations tooltip',
    defaultMessage: 'Linked Ship From Locations',
    id: 'Ja4PsO',
  },
  shipFromsCount: {
    description: 'Message to indicate how many ship froms exists',
    defaultMessage: '{count} Ship Froms',
    id: '8E5//E',
  },
  changeWarehouse: {
    description: 'Label for the button to change the warehouse',
    defaultMessage: 'Change Warehouse',
    id: 'Oc4bND',
  },
  errorCreatingTotesTitle: {
    description: 'Error title when creating totes fails',
    defaultMessage: 'Error Creating Totes',
    id: 'qocjr2',
  },
  errorCreatingTotesDescription: {
    description: 'Error message when creating totes fails',
    defaultMessage: 'An unknown error occurred creating the totes. Please contact support for additional assistance.',
    id: '3jr1eV',
  },
  successCreatingTotesTitle: {
    description: 'Success title when totes are created successfully',
    defaultMessage: 'Success',
    id: 'N0TRKr',
  },
  successCreatingTotesDescription: {
    description: 'Success message when totes are created successfully',
    defaultMessage: 'Your totes have been created successfully.',
    id: 'M0ShSE',
  },
  successCreatingTotesWithCountDescription: {
    description: 'Success message when totes are created successfully with count',
    defaultMessage: '{count, plural, one {# tote has} other {# totes have}} been created successfully.',
    id: 'Irpzby',
  },
  partialSuccessCreatingTotesDescription: {
    description: 'Message when some totes are created and some failed',
    defaultMessage: '{failedItems, plural, one {# tote was not created} other {# totes were not created}}. Please check the details below.',
    id: '8jhJBL',
  },
  successCreatingAndPrintingTotesTitle: {
    description: 'Success title when totes are created and printed successfully',
    defaultMessage: 'Success',
    id: 'Rgk/42',
  },
  successCreatingAndPrintingTotesDescription: {
    description: 'Success message when totes are created and printed successfully',
    defaultMessage: 'Your totes have been created and barcodes have been printed successfully.',
    id: 'LD869x',
  },
  successCreatingAndPrintingTotesWithCountDescription: {
    description: 'Success message when totes are created and printed successfully with count',
    defaultMessage: '{count, plural, one {# tote has} other {# totes have}} been created and barcodes have been printed successfully.',
    id: '/wHZtb',
  },
  errorPrintingTotesDescription: {
    description: 'Error message when totes are created but printing fails',
    defaultMessage:
      'Your totes have been created successfully, but there was an error printing the barcodes. You can print them manually from the totes table.',
    id: 'GsA9XJ',
  },
});

export default messages;
